// extracted by mini-css-extract-plugin
export default {"cls1":"_uDv7RAnHdnJ3mLsM446","cls2":"ug24xQs3UkmseQ3XBaSc _uDv7RAnHdnJ3mLsM446","isTabletDown":"mJS71EZzeyNV_tJrCc3p","isPhone":"jldyod707Eh06T7SCMfJ"};